import axios from 'axios';
import ValidateTokenExistence from '../../middlewares/ValidateTokenExistence';
const API_URL = `${process.env.REACT_APP_SERVER_USERS}`;

export const axiosClient = axios.create({
    baseURL: API_URL,
});

axiosClient.interceptors.request.use(async (config) => {
    try {
        if (config.url !== '/auth/sign-in') {
            const token = localStorage.getItem("token");
            await ValidateTokenExistence(config, token)
            return config;
        }
      } catch(e) {
        console.log(e);
      }
});